import React, {Fragment} from "react";
import NsDataTable from "../../../components/tabelle/NsDataTable";

export default function PermessiKpiView({
                                            permessiKpi,
                                            translate,
                                            onChangeConfigurazione,
                                            onChangeAllLettura,
                                            onChangeLettura,
                                            onChangeAllScrittura,
                                            onChangeScrittura,
                                            onChangeAllApprovazione,
                                            onChangeApprovazione,
                                            onChangeAllRevisione,
                                            onChangeRevisione,
                                            onChangeAllConfigurazione,
                                        }) {

    return (
        <NsDataTable
            data={permessiKpi}
            columns={[
                {
                    name: translate('Codice'),
                    selector: row => row.codice,
                    sortable: true,
                },
                {
                    name: translate('Descrizione'),
                    selector: row => row.descrizione,
                    sortable: true,
                },
                {
                    name: translate('Riferimento'),
                    selector: row => row.tipo_imp_dati,
                    sortable: true,
                },
                {
                    name: translate('Macrocategoria'),
                    selector: row => row.kpi_macrocategoria,
                    sortable: true,
                },
                {
                    name: <Fragment>
                        <input
                            type={"checkbox"}
                            name={"all_lettura"}
                            className={"form-contorl"}
                            onChange={onChangeAllLettura}
                        />&nbsp;{translate('Lettura')}
                    </Fragment>,
                    selector: row => <input
                        type={"checkbox"}
                        name={'lettura_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                        id={'lettura_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                        className={"form-contorl"}
                        checked={row.lettura == '1'}
                        onChange={(e) => {
                            onChangeLettura(e, row);
                        }}
                    />,
                    sortable: false,
                },
                {
                    name: <Fragment>
                        <input
                            type={"checkbox"}
                            name={"all_scrittura"}
                            className={"form-contorl"}
                            onChange={onChangeAllScrittura}
                        />&nbsp;{translate('Scrittura')}
                    </Fragment>,
                    selector: row => <input
                        type={"checkbox"}
                        name={'scrittura_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                        id={'scrittura_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                        className={"form-contorl"}
                        checked={row.scrittura == '1'}
                        onChange={(e) => {
                            onChangeScrittura(e, row);
                        }}
                    />,
                    sortable: false,
                },
                {
                    name: <Fragment>
                        <input
                            type={"checkbox"}
                            name={"all_approvazione"}
                            className={"form-contorl"}
                            onChange={onChangeAllApprovazione}
                        />&nbsp;{translate('Approvazione')}
                    </Fragment>,
                    selector: row => <input
                        type={"checkbox"}
                        name={'approvazione_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                        id={'approvazione_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                        className={"form-contorl"}
                        checked={row.approvazione == '1'}
                        onChange={(e) => {
                            onChangeApprovazione(e, row);
                        }}
                    />,
                    sortable: false,
                },
                {
                    name: <Fragment>
                        <input
                            type={"checkbox"}
                            name={"all_revisione"}
                            className={"form-contorl"}
                            onChange={onChangeAllRevisione}
                        />&nbsp;{translate('Revisione')}
                    </Fragment>,
                    selector: row => <input
                        type={"checkbox"}
                        name={'revisione_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                        id={'revisione_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                        className={"form-contorl"}
                        checked={row.revisione == '1'}
                        onChange={(e) => {
                            onChangeRevisione(e, row);
                        }}
                    />,
                    sortable: false,
                },
                {
                    name: <Fragment>
                        <input
                            type={"checkbox"}
                            name={"all_configurazione"}
                            className={"form-contorl"}
                            onChange={onChangeAllConfigurazione}
                        />&nbsp;{translate('Configurazione')}
                    </Fragment>,
                    selector: row => <input
                        type={"checkbox"}
                        name={'configurazione_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                        id={'configurazione_' + row.id_kpi + '_' + row.id_tipo_imp_dati}
                        className={"form-contorl"}
                        checked={row.configurazione == '1'}
                        onChange={(e) => {
                            onChangeConfigurazione(e, row);
                        }}
                    />,
                    sortable: false,
                }
            ]}
        />
    );
}